<template>
    <div v-if="isActive" id="customCard-action-container" class="custom-card-action-container">
    </div>
</template>

<script src='./credit-cards-3ds.js'></script>